import React from 'react'
import HomeContainer from '../components/home/HomeContainer'

const Home = () => {
  return (
    <HomeContainer />
  )
}

export default Home